@switch (env.appType) {
  @default () {
    <app-main></app-main>
  }
}
